import { useEffect, useState } from 'react';
import HeroBanner from '../../components/HeroBanner/HeroBanner';
import CategoryGrid from '../../components/Category/CategoryGrid';
import EventList from '../../components/Event/EventList';
import './Dashboard.css';

import { db } from '../../firebase';
import { collection, onSnapshot } from 'firebase/firestore';

function getDateObj(date) {
  if (!date) return null;
  if (typeof date.toDate === 'function') {
    return date.toDate();
  }
  const d = new Date(date);
  return isNaN(d) ? null : d;
}

function Dashboard() {
  const [categories, setCategories] = useState([]);
  const [events, setEvents] = useState([]);
  const [showAllCategories, setShowAllCategories] = useState(false);
  const [showAllEvents, setShowAllEvents] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, 'categories'),
      (snapshot) => {
        setCategories(snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })));
      }
    );
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, 'events'),
      (snapshot) => {
        setEvents(snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })));
      }
    );
    return () => unsubscribe();
  }, []);

  
  const sortedEvents = [...events].sort((a, b) => {
    const dateA = getDateObj(a.date);
    const dateB = getDateObj(b.date);
    if (!dateA || !dateB) return 0;
    return dateB - dateA;
  });

  const displayedCategories = showAllCategories ? categories : categories.slice(0, 6);

  const filteredEvents = selectedCategory
    ? sortedEvents.filter(ev =>
        ev.categoryId === selectedCategory.id || ev.category === selectedCategory.name
      )
    : sortedEvents;

  const displayedEvents = showAllEvents ? filteredEvents : filteredEvents.slice(0, 5);

  const handleCategoryClick = (categoryObj) => {
    setSelectedCategory(categoryObj);
    setShowAllEvents(true);
  };

  const handleEventButtonClick = () => {
    if (selectedCategory) {
      setSelectedCategory(null);
      setShowAllEvents(false);
    } else {
      setShowAllEvents(prev => !prev);
    }
  };

    return (
    <div className="dashboard">
      <HeroBanner />

      {/* CATEGORIES SECTION */}
      <section className="dashboard-section">
        <div className="dashboard-section-header">
          <h2>Categories</h2>
          <button
            className="see-more-btn"
            onClick={() => setShowAllCategories(prev => !prev)}
          >
            {showAllCategories ? 'Show less' : 'See more categories'}
          </button>
        </div>
        <CategoryGrid 
          categories={displayedCategories} 
          onCategoryClick={handleCategoryClick}
        />
      </section>

      {/* EVENTS SECTION */}
      <section className="dashboard-section">
        <div className="dashboard-section-header">
          <h2>
            {selectedCategory 
              ? `Events in "${selectedCategory.name}"` 
              : 'Latest Events'}
          </h2>
          <button 
            className="see-more-btn" 
            onClick={handleEventButtonClick}
          >
            {selectedCategory 
              ? 'Show all events' 
              : showAllEvents ? 'Show less' : 'See all events'}
          </button>
        </div>
        <EventList events={displayedEvents} />
      </section>
    </div>
  );
}

export default Dashboard;